import { searchDefaults, selectors } from "../constants/search-constants"

export const getScope = (locale: string, brand: string): string => {
  return `//${searchDefaults.UNIVERSE}/${locale}/${selectors.BRAND_SELECTOR}>{${brand}}`
}
